import editCoordinators from './edit'
import * as proposalCoordinators from './proposal'

export default Object.freeze({
  ...editCoordinators,
  ...proposalCoordinators,
})
